import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { paths } from 'src/routes/paths';

import { selectUser } from 'src/redux/auth/selectors';

import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  user: icon('ic_user'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  contact: icon('ic_menu_item'),
  godowns: icon('ic_tour'),
  branches: icon('ic_folder'),
  staff: icon('ic_lock'),
  purchase: icon('ic_ecommerce'),
  sales: icon('ic_external'),
  returns: icon('ic_label'),
  payments: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  let userPermissions = useSelector(selectUser);
  userPermissions = userPermissions?.custom_permissions || [];

  const data = useMemo(() => {
    const modules = [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'overview',
        items: [
          {
            title: 'Dashboard',
            path: paths.dashboard.root,

            icon: ICONS.dashboard,
          },
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: 'management',
        items: [
          // {
          //   title: 'edutainment',
          //   path: paths.dashboard.edutainment.root,
          //   icon: ICONS.contact,
          //   // children: [
          //   //   { title: 'list', path: paths.dashboard.edutainment.root },
          //   //   { title: 'create', path: paths.dashboard.edutainment.new },
          //   // ],
          // },

          // {
          //   title: 'polls',
          //   path: paths.dashboard.polls.root,
          //   icon: ICONS.contact,
          //   // children: [
          //   //   { title: 'list', path: paths.dashboard.polls.root },
          //   //   { title: 'create', path: paths.dashboard.polls.new },
          //   // ],
          // },

          {
            title: 'schools',
            path: paths.dashboard.schools.root,
            icon: ICONS.contact,
          },

          {
            title: 'Grades',
            path: paths.dashboard.grades.root,
            icon: ICONS.contact,
          },

          {
            title: 'Students',
            path: paths.dashboard.students.root,
            icon: ICONS.contact,
            // children: [
            //   { title: 'list', path: paths.dashboard.students.root },
            //    { title: 'create', path: paths.dashboard.students.new },
            // ],
          },

          {
            title: 'edutainment',
            path: paths.dashboard.edutainment.root,
            icon: ICONS.contact,
           children: [
              {
                title: 'Feeds',
                path: paths.dashboard.edutainment.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
                //   { title: 'Create', path: paths.dashboard.offlinecourse.new },
                // ],
              },
               {
                title: 'Prosperity-Tips',
                path: paths.dashboard.prosperitytips.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
               
                // ],
              },
               {
                title: 'P-tips',
                path: paths.dashboard.ptips.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
                //   { title: 'Create', path: paths.dashboard.offlinecourse.new },
                // ],
              },
                 {
                title: 'Stories',
                path: paths.dashboard.stories.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
                //   { title: 'Create', path: paths.dashboard.offlinecourse.new },
                // ],
              },
              {
                title: 'categories',
                path: paths.dashboard.feeds_categories.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.host.root },
                //   { title: 'Create', path: paths.dashboard.host.new },
                // ],
              },
             
            ],
          },

          {
            title: 'News',
            path: paths.dashboard.news.root,
            icon: ICONS.contact,
             children: [
              {
                title: 'News',
                path: paths.dashboard.news.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
                //   { title: 'Create', path: paths.dashboard.offlinecourse.new },
                // ],
              },
              {
                title: 'categories',
                path: paths.dashboard.categories.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.host.root },
                //   { title: 'Create', path: paths.dashboard.host.new },
                // ],
              },
             
            ],
            
          },

          {
            title: 'calender',
            path: paths.dashboard.calender.root,
            icon: ICONS.contact,
          },

          {
            title: 'Offine Courses',
            path: paths.dashboard.offlinecourse.root,
            icon: ICONS.contact,
            children: [
              {
                title: 'Offline Courses',
                path: paths.dashboard.offlinecourse.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.offlinecourse.root },
                //   { title: 'Create', path: paths.dashboard.offlinecourse.new },
                // ],
              },
              {
                title: 'Host',
                path: paths.dashboard.host.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.host.root },
                //   { title: 'Create', path: paths.dashboard.host.new },
                // ],
              },
              {
                title: 'Webinar',
                path: paths.dashboard.webinar.root,
              },
            ],
          },

          {
            title: 'Online Courses',
            path: paths.dashboard.onlinecourses.root,
            icon: ICONS.contact,
             children: [
              {
                title: 'Courses',
                path: paths.dashboard.onlinecourses.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.word.root },
                //   { title: 'Create', path: paths.dashboard.word.new },

                // ],
              },
               {
                title: 'Chapters',
                path: paths.dashboard.chapters.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.word.root },
                //   { title: 'Create', path: paths.dashboard.word.new },

                // ],
              },
              {
                title: 'Lessons',
                path: paths.dashboard.lessons.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.competition.root },
                //   { title: 'Create', path: paths.dashboard.competition.new },

                // ],
              },
            ],
            
          },

          {
            title: 'Vocabee',
            path: paths.dashboard.word.root,
            icon: ICONS.contact,
            children: [
              {
                title: 'Word',
                path: paths.dashboard.word.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.word.root },
                //   { title: 'Create', path: paths.dashboard.word.new },

                // ],
              },
              {
                title: 'Competition',
                path: paths.dashboard.competition.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.competition.root },
                //   { title: 'Create', path: paths.dashboard.competition.new },

                // ],
              },
            ],
          },

          {
            title: 'Gallery',
            path: paths.dashboard.gallery.root,
            icon: ICONS.contact,
          },

          {
            title: 'Lessons',
            path: paths.dashboard.lessons.root,
            icon: ICONS.contact,
          },

          {
            title: 'MCQs',
            path: paths.dashboard.mcqs.root,
            icon: ICONS.contact,
          },

          {
            title: 'banner',
            path: paths.dashboard.banner.root,
            icon: ICONS.contact,
          },

          // {
          //   title: 'Events',
          //   path: paths.dashboard.events.root,
          //   icon: ICONS.contact,
          // },

          {
            title: 'School Info',
            path: paths.dashboard.school_info.root,
            icon: ICONS.contact,
          },

          {
            title: 'Feels',
            path: paths.dashboard.feels.root,
            icon: ICONS.contact,
          },

          {
            title: 'Online Stores',
            path: paths.dashboard.onlinecategories.root,
            icon: ICONS.contact,
            children: [
              {
                title: ' Categories',
                path: paths.dashboard.onlinecategories.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlinecategories.root },
                //   { title: 'Create', path: paths.dashboard.onlinecategories.new },
                // ],
              },
              {
                title: ' Products',
                path: paths.dashboard.onlinestoreproducts.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlinestoreproducts.root },
                //   { title: 'Create', path: paths.dashboard.onlinestoreproducts.new },
                // ],
              },
              {
                title: 'Orders',
                path: paths.dashboard.onlineorders.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlineorders.root },
                // ],
              },
            ],
          },

          {
            title: 'Curriculum',
            path: paths.dashboard.curriculum.root,
            icon: ICONS.contact,
            children: [
                {
                title: 'Curriculum',
                path: paths.dashboard.curriculum.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlinecategories.root },
                //   { title: 'Create', path: paths.dashboard.onlinecategories.new },
                // ],
              },
              {
                title: ' Categories',
                path: paths.dashboard.curriculum_categories.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlinecategories.root },
                //   { title: 'Create', path: paths.dashboard.onlinecategories.new },
                // ],
              },
              {
                title: ' Subjects',
                path: paths.dashboard.curriculum_subjects.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlinestoreproducts.root },
                //   { title: 'Create', path: paths.dashboard.onlinestoreproducts.new },
                // ],
              },
              {
                title: 'Lessons',
                path: paths.dashboard.curriculum_lessons.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlineorders.root },
                // ],
              },
              {
                title: 'Concept',
                path: paths.dashboard.curriculum_concept.root,
                // children: [
                //   { title: 'List', path: paths.dashboard.onlineorders.root },
                // ],
              },
                  {
                title: 'Questions',
                path: paths.dashboard.assessment_question.root,
              
              },
            ],
          },

          // {
          //   title: 'Homework',
          //   path: paths.dashboard.homework.root,
          //   icon: ICONS.contact,
          // },

          {
            title: 'Avatar',
            path: paths.dashboard.avatar.root,
            icon: ICONS.contact,
          },

           {
            title: 'Completed Homework',
            path: paths.dashboard.completed_homework.root,
            icon: ICONS.contact,
          },

            // {
            //     title: 'Subject',
            //     path: paths.dashboard.subject.root,
            //     icon: ICONS.contact,
              
            //   },


          //       {
          //   title: 'Assessment',
          //   path: paths.dashboard.assessment.root,
          //   icon: ICONS.contact,
          //   children: [
          //     {
          //       title: 'Assessment',
          //       path: paths.dashboard.assessment.root,
              
          //     },
            
          //     {
          //       title: 'Questions',
          //       path: paths.dashboard.assessment_question.root,
              
          //     },

          //       {
          //       title: 'Answers',
          //       path: paths.dashboard.assessment_answers.root,
              
          //     },

          //     //   {
          //     //   title: 'Results',
          //     //   path: paths.dashboard.assessment_results.root,
              
          //     // },
          //   ],
          // },


           

          //  {
          //   title: 'Fee',
          //   path: paths.dashboard.fee.root,
          //   icon: ICONS.contact,
          //   children: [
          //     {
          //       title: 'Fee Term',
          //       path: paths.dashboard.fee.root,
              
          //     },
          //     {
          //       title: 'Fee Structure',
          //       path: paths.dashboard.fee_structure.root,
                
          //     },
          //   ],
          // },


              {
            title: 'New Broadcast',
            path: paths.dashboard.broadcast.root,
            icon: ICONS.contact,
          },





























        ],
      },
    ];

    const filteredModules = modules
      .map((module) => {
        const filteredItems = module.items.reduce((acc, item) => {
          if (
            !item.permissions ||
            item.permissions.some((permission) => userPermissions.includes(permission))
          ) {
            if (!item.children) {
              acc.push(item);
            } else {
              const filteredChildren = item.children.filter(
                (child) =>
                  !child.permissions ||
                  child.permissions.some((permission) => userPermissions.includes(permission))
              );
              if (filteredChildren.length > 0) {
                acc.push({ ...item, children: filteredChildren });
              }
            }
          }
          return acc;
        }, []);

        return {
          ...module,
          items: filteredItems,
        };
      })
      .filter((module) => module.items.length > 0);

    return filteredModules;
  }, [userPermissions]);

  return data;
}
